import React, { useState, useEffect, useContext, useRef } from "react";
import * as S from "./styles";
import iconUser from "../../assets/user/account-circle.svg";
import iconPapeis from "../../assets/navbar/Convenios_on_light_blue.svg";

import Button from "../Button";
import api from "../../services/api";
import { BiTrash } from "react-icons/bi";

import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";

import InputMask from "react-input-mask";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import { toast } from "react-toastify";
import { Context } from "../../context/globalContext";
import { mask } from "../../utils/mask";
import { Formik, Form, Field } from "formik";

import PopUp from "../PopUp";
import SkeletonListItem from "../SkeletonListItem";
import CheckBox from "../Checkbox";
import Skeleton from "../skeleton";
import Select from "react-select";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

export default function PermissionListComponent({ history, pageFilter }) {
  const { setIsLoading, isLoading } = useContext(Context);
  const classes = useStyles();
  const formRef = useRef(null);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageLimit, setPageLimit] = useState(9);
  const [popupOpen, setPopupOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({ id: null, cpf: null });

  const [administrador, setAdministrador] = useState(false);
  const [credito, setCredito] = useState(false);
  const [inputState, setInputState] = useState(false);

  const [users, setUsers] = useState([]);
  const [initialState, setInitialState] = useState({
    addName: null,
    addChave: null,
    id: null,
    selectPermission: {},
  });

  async function getAllData(page = 0) {
    try {
      setIsLoading(true);
      const response = await api.get(
        `/api/permissoes?page=${page}&size=${pageLimit}`
      );

      if (response && (response.status === 201 || response.status === 200)) {
        setUsers(response.data.content);
        setPage(page);
        setTotalPages(response.data.totalPages);
        setTotalElements(response.data.totalElements);
      } else if (!response) {
        setUsers([]);
        setTotalPages(0);
        setTotalElements(0);
        toast.error("Erro ao buscar aos papéis de usuários.");
      }

      setIsLoading(false);
    } catch (err) {
      setTotalPages(0);
      setTotalElements(0);
      setUsers([]);
      setIsLoading(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar aos papéis de usuários.");
      }
    }
    setIsLoading(false);
  }

  useEffect(() => {
    if (pageFilter) {
      setPage(pageFilter);
    }

    getAllData(pageFilter);
  }, [pageFilter]);

  const reloadPage = (page) => {
    history.replace(`?page=${page}`);
  };

  const sendData = async (dataForm) => {
    if (!dataForm?.addName || dataForm?.addName === null) {
      toast.error("Preencha um nome para a permissão.");
      return;
    }

    if (!dataForm?.addChave || dataForm?.addChave === null) {
      toast.error("Preencha uma chave para a permissão.");
      return;
    }

    const dataSending = {
      descricao: dataForm.addName,
      chave: dataForm.addChave,
      status: true,
    };

    try {
      const response = await api.post("/api/permissoes", dataSending);
      if (response && (response.status === 201 || response.status === 200)) {
        toast.success("Dados cadastrados com sucesso!");
      } else if (!response) {
        toast.error(
          "Erro ao salvar dados, verifique os dados e tente novamente!"
        );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao salvar dados, verifique os dados e tente novamente!"
        );
      }
    } finally {
      setInitialState({
        addName: null,
        addChave: null,
        id: null,
        selectPermission: null,
      });

      getAllData();
    }
  };

  const HandleSubmit = (values) => {
    sendData(values);
  };

  return (
    <>
      <S.Container>
        <S.Card>
          <Formik
            initialValues={initialState}
            onSubmit={async (values) => HandleSubmit}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <div className="boxSearch">
                  <Field
                    name="addName"
                    id="addName"
                    render={({ field }) => (
                      <InputMask
                        type="text"
                        placeholder="Descrição da permissão"
                        value={values.addCPF}
                        onChange={(e) => {
                          setFieldValue("addName", e.target.value);
                        }}
                      />
                    )}
                  />
                  <S.InputBox>
                    <Field
                      name="addChave"
                      id="addChave"
                      render={({ field }) => (
                        <InputMask
                          type="text"
                          placeholder="Chave da permissão"
                          value={values.addChave}
                          onChange={(e) => {
                            setFieldValue("addChave", e.target.value);
                          }}
                        />
                      )}
                    />
                  </S.InputBox>

                  <Button
                    type="submit"
                    className="button"
                    onClick={() => HandleSubmit(values)}
                  >
                    Cadastrar permissão
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
          <S.CardHeader>
            <span>
              {`${totalElements} ${
                totalElements > 1 ? "permissões" : "Permissão"
              } cadastrado${totalElements > 1 ? "s" : ""} no sistema`}
            </span>
          </S.CardHeader>

          {!isLoading ? (
            <S.CardBody>
              {users &&
                users?.map((user) => {
                  return (
                    <>
                      <S.Custumer>
                        <S.Info>
                          <img src={iconPapeis} alt="Icone usuário" />
                          <div className="dataCard">
                            <h4 className="h4-info">
                              {user?.descricao + " (" + user?.chave + ")" || ""}
                            </h4>
                          </div>
                        </S.Info>
                        <div className="iconService">
                          <BiTrash
                            id="trashIcon"
                            color="#00a2e0"
                            size={25}
                            onClick={() => {
                              setPopupOpen(true);
                              setUserSelected({ id: user.id, cpf: user.cpf });
                            }}
                          />
                        </div>
                      </S.Custumer>
                    </>
                  );
                })}

              {totalPages > 1 && (
                <TablePagination
                  component="div"
                  classes={{
                    toolbar: classes.toolbar,
                    caption: classes.caption,
                  }}
                  count={totalElements}
                  page={page}
                  labelDisplayedRows={({ from, to, count }) => {
                    return from + " - " + to + " de " + count;
                  }}
                  onPageChange={(p, newPage) => reloadPage(newPage)}
                  rowsPerPageOptions={[]}
                  rowsPerPage={pageLimit}
                />
              )}
            </S.CardBody>
          ) : (
            <SkeletonListItem />
          )}
        </S.Card>
      </S.Container>
      {popupOpen && (
        <PopUp
          setIsLoading={setIsLoading}
          setOpenPopup={setPopupOpen}
          userSelected={userSelected}
          page={page}
          updateList={getAllData}
          endPoint="/api/permissoes/"
          useMask="###.###.###-##"
          inativar={false}
          showCpfCnpj={false}
          textExclude={"Você deseja realmente excluir esta permissão?"}
          messageFailed={"Error ao excluir a permissão"}
          messageSuccess={"Sucesso ao excluir a permissão"}
        />
      )}
    </>
  );
}
